// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"iq-z","giftOrPromoSelector":"jq-z","disabled":"kq-z","subTitle":"lq-z","selectShipAddressMessage":"mq-z","changePayment":"nq-z"};